import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-daf835da"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "cart-modal",
  class: "modal opacity-0 pointer-events-none fixed w-full h-full top-0 left-0 flex items-center justify-center z-20"
}
const _hoisted_2 = { class: "modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto" }
const _hoisted_3 = { class: "modal-content py-4 text-left px-6" }
const _hoisted_4 = { class: "flex justify-between items-center pb-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-2xl font-bold" }, "Carrello", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-current text-black",
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "text-sm mb-7" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Stai effettuando un ordine per il giorno ")
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "uppercase text-xs" }, "Riepilogo ordine", -1))
const _hoisted_12 = { class: "mt-2 mb-4" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 inline mr-2 text-grey-300",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
  })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "product-name flex-grow" }
const _hoisted_17 = { class: "format" }
const _hoisted_18 = { class: "cart-item py-4 px-2 border-t-2 flex justify-between text-sm" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "product-name font-bold" }, "TOTALE", -1))
const _hoisted_20 = { class: "quantity font-bold tabular-nums" }
const _hoisted_21 = { class: "flex justify-end" }
const _hoisted_22 = {
  key: 1,
  type: "button",
  class: "inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 w-full opacity-60 cursor-not-allowed"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Invio in corso... ")
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 2,
  type: "button",
  class: "inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 w-full opacity-50 cursor-not-allowed"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Stepper = _resolveComponent("Stepper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal())),
      class: "modal-overlay absolute w-full h-full bg-gray-900 opacity-60"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "modal-close cursor-pointer z-50",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleModal()))
          }, _hoisted_7)
        ]),
        _createElementVNode("p", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.giornoFormattato), 1)
        ]),
        _hoisted_11,
        _createElementVNode("ul", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.righe, (riga) => {
            return (_openBlock(), _createElementBlock("li", {
              key: riga.prod.id,
              class: "cart-item py-2 px-0 border-b border-t flex justify-between text-sm"
            }, [
              _createElementVNode("span", {
                class: "delect-product flex-none",
                onClick: ($event: any) => (_ctx.maybeRimuoviRiga(riga.prod.id)),
                title: "rimuovi"
              }, _hoisted_15, 8, _hoisted_13),
              _createElementVNode("p", _hoisted_16, [
                _createTextVNode(_toDisplayString(riga.prod.nome) + " ", 1),
                _createElementVNode("span", _hoisted_17, "(" + _toDisplayString(riga.prod.formato) + ")", 1)
              ]),
              _createVNode(_component_Stepper, {
                modelValue: riga.qta,
                "onUpdate:modelValue": ($event: any) => ((riga.qta) = $event),
                integer: "",
                min: "0",
                "input-width": "40px",
                "button-size": "24px",
                onChange: _ctx.updateQta,
                name: `prod${riga.prod.id}`,
                "before-change": _ctx.maybeDelete,
                onClick: ($event: any) => (_ctx.click(riga.prod.id))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "name", "before-change", "onClick"])
            ]))
          }), 128)),
          _createElementVNode("li", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("p", _hoisted_20, "€ " + _toDisplayString(_ctx.prezzo.toFixed(2)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          ((_ctx.ordiniAperti || _ctx.isAdmin) && !_ctx.ordineInInvio && _ctx.righe.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.inviaOrdine && _ctx.inviaOrdine(...args))),
                class: "inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 w-full"
              }, " Invia ordine "))
            : _createCommentVNode("", true),
          (_ctx.ordineInInvio)
            ? (_openBlock(), _createElementBlock("button", _hoisted_22, _hoisted_25))
            : _createCommentVNode("", true),
          (!(_ctx.ordiniAperti || _ctx.isAdmin))
            ? (_openBlock(), _createElementBlock("button", _hoisted_26, " Gli ordini riaprono alle 7:00 "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}